import { render } from "./AffectationForm.vue?vue&type=template&id=5d527188"
import script from "./AffectationForm.vue?vue&type=script&lang=js"
export * from "./AffectationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__